import './ticket-meta-form.less';
import PropTypes from 'prop-types';
import React from 'react';
import {Field, reduxForm } from 'redux-form';
import find from 'lodash/find';
import get from 'lodash/get';
import { enum as affiliateLevelsEnum } from '../../../../../../enums/affiliate-levels';
import { enum as threadCategoriesEnum } from '../../../../../../enums/thread-categories';

import CheckboxField from '../../shared/form-elements/checkbox';

const propsTypes = {
	affiliate: PropTypes.object,
	affiliateLevelList: PropTypes.array,
	handleSubmit: PropTypes.func,
	intl: PropTypes.func,
	submitForm: PropTypes.func,
	changeAffiliateLevel: PropTypes.func,
	pendingOfferAccessRequests: PropTypes.array,
	values: PropTypes.object,
	ticketMetaFormValue: PropTypes.object,
	rejectOfferAccess: PropTypes.func,
	can: PropTypes.func,
	toggleCloseForm: PropTypes.func,
	category: PropTypes.string,
	isClosed: PropTypes.bool,
	isGiftOrder: PropTypes.bool
};

const isRocket = process.env.CPA_ENV === 'rocket';

const Form = ({
	affiliate,
	affiliateLevelList,
	handleSubmit,
	submitForm,
	intl,
	changeAffiliateLevel,
	pendingOfferAccessRequests,
	ticketMetaFormValue,
	rejectOfferAccess,
	can,
	toggleCloseForm,
	category,
	isClosed,
	isGiftOrder
}) => {
	const closeTicketPermission = (isRocket && isGiftOrder)
		? 'closeGiftOrderTicket'
		: 'closeTicket';

	const shouldShow = pendingOfferAccessRequests.length > 0 && can('answer');
	const shouldDisable = getDisabledStatus(ticketMetaFormValue);

	const canActivate = isRocket
		&& can('changeLevel')
		&& category === threadCategoriesEnum.affiliate_appeal
		&& affiliate.level && affiliate.level !== affiliateLevelsEnum.average;

	return (
		<div className="ticket__meta-form">
			<form
				className="ui-form meta-form"
				onSubmit={handleSubmit(data => submitForm(data))}>
				{ shouldShow &&  <p className="meta-form_title">{intl('Offer(s) access request')}</p> }

				<div className="meta-form__offers-list">
					{ shouldShow && pendingOfferAccessRequests.map(access => (
						<div className="ui-form__element" key={access.offer_id}>
							<Field
								name={`offers[${access.offer_id}]`}
								placeholder={access.offer}
								normalize={v => !!v }
								component={CheckboxField} />
						</div>
					)) }
				</div>

				<div className="btn-wrap">
					{ shouldShow && (
						<div className="ui-form__element">
							<button className="ui-btn ui-btn-action" disabled={shouldDisable}>{ intl('Open access') }</button>
						</div>
					) }

					{ !isRocket && can('changeLevel') && (
						<div className="ui-form__element">
							<button
								className="ui-btn ui-btn-action"
								onClick={e => {
									e.preventDefault();
									changeAffiliateLevel(
										get(getAffiliateLevelForRequest(affiliate.level, affiliateLevelList), 'id')
									);
								}}>{intl(
									'Level to %s',
									`"${get(getAffiliateLevelForRequest(affiliate.level, affiliateLevelList), 'text')}"`
								)}</button>
						</div>
					) }
					{ canActivate && (
						<div className="ui-form__element">
							<button
								className="ui-btn ui-btn-action"
								onClick={e => {
									e.preventDefault();
									changeAffiliateLevel(affiliateLevelsEnum.average);
								}}>{intl('Activate')}</button>
						</div>
					) }

					{ shouldShow && (
						<div className="ui-form__element">
							<button
								className="ui-btn ui-btn-cancel"
								onClick={e => {
									e.preventDefault();
									rejectOfferAccess();
								}}
								disabled={shouldDisable}>{ intl('Reject access') }</button>
						</div>
					) }

					{ can(closeTicketPermission) && !isClosed && (
						<div className="ui-form__element">
							<button
								className="ui-btn ui-btn-cancel"
								onClick={e => {
									e.preventDefault();
									toggleCloseForm();
								}}>{ intl('Close ticket') }</button>
						</div>
					) }
				</div>
			</form>
		</div>
	);
};

const getAffiliateLevelForRequest = (level, affiliateLevelList) => {
	const id = affiliateLevelsEnum.noob === level ? affiliateLevelsEnum.average : affiliateLevelsEnum.noob;
	return {
		id,
		text: get(find(affiliateLevelList, { id }), 'text')
	};
};

const getDisabledStatus = formValue => {
	if (!formValue) return true;
	return !formValue.offers.filter(offer => offer).length;
};

Form.propTypes = propsTypes;

export default reduxForm({
	form: 'ticketMetaForm'
})(Form);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/ticket-meta-form.js